export default {
  computed: {
    isResellerRoute () {
      return this.$route.meta.parent === 'hosting_reseller'
    }
  }
}
